import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatCheckbox, MatCheckboxClickAction} from '@angular/material';
import {DiversityInsightService} from '../../service/diversity-insight.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'diversity-insight-legend-item',
  templateUrl: './diversity-insight-legend-item.component.html',
  styleUrls: ['./diversity-insight-legend-item.component.scss']
})
export class DiversityInsightLegendItemComponent {

  @ViewChild('checkbox') checkbox: MatCheckbox;

  @Input() label: string;
  @Input() id: string;
  @Input() color: string;
  @Input() isStage: number;
  @Input() numOfDemographics: number;
  @Output() itemClickedEvent = new EventEmitter<{}>();
  minSelectedAmount = 1;

  constructor(public diversityInsightService: DiversityInsightService,
              public Translate: TranslateService) {}

  itemClicked(event: PointerEvent) {
    event.preventDefault();
    const label = this.checkbox.id.replace('-input', '');
    const checked = this.checkbox.checked;
    const atMinimumStageCount = this.isStage && this.getNumberOfSelectedStages() === this.minSelectedAmount;
    const atMinimumDemographicCount = !this.isStage &&
      this.numOfDemographics - this.diversityInsightService.hiddenDemographics.length === this.minSelectedAmount;
    if (!((atMinimumStageCount || atMinimumDemographicCount) && checked)) {
      // It has the old value at this point in the click event. So it is safe to assume it is the opposite for the user clicked it.
      this.itemClickedEvent.emit({label: label, checked: !checked, isStage: this.isStage});

      if (this.isStage) {
        const currentStageSelection = this.diversityInsightService.stageStatus;

        this.diversityInsightService.stageStatus = {
          submitted: this.Translate.instant('diversity.submitted') === this.label ? !checked : currentStageSelection.submitted,
          interviewed: this.Translate.instant('diversity.interviewed') === this.label ? !checked : currentStageSelection.interviewed,
          hired: this.Translate.instant('diversity.hired') === this.label ? !checked : currentStageSelection.hired,
        };
      } else {
        if (!checked) {
          this.diversityInsightService.hiddenDemographics = this.diversityInsightService.hiddenDemographics
                                                                .filter(demographic => demographic !== this.label);
        } else {
          this.diversityInsightService.hiddenDemographics.push(this.label);
        }
      }
    }
  }

  getStageSelectedStatus() {
    return this.diversityInsightService.getStageDisplayStatus(this.label);
  }

  getDemographicSelectedStatus() {
    return !this.diversityInsightService.hiddenDemographics.includes(this.label);
  }

  getNumberOfSelectedStages() {
    // essentially checking the number of 'true' values
    return Object.values(this.diversityInsightService.stageStatus).filter(selectedStatus => selectedStatus).length;
  }
}
